import type { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { useChat } from '../../chat';
import { useWindowPosition } from '../utils';

export const FloatingWindow = ({ children }: PropsWithChildren) => {
  const { openChatWindow } = useChat();
  const { renderThumbnailMode } = useSettings();
  const { top, right, bottom, left, width, options } = useWindowPosition();

  return (
    <Container
      _width={width}
      _openWindow={openChatWindow}
      _thumbnailMode={renderThumbnailMode}
      style={{ top, right, bottom, left, ...options }}
    >
      {children}
    </Container>
  );
};

const Container = styled.div<{
  _width: string | number;
  _openWindow: boolean;
  _thumbnailMode?: boolean;
}>`
  position: fixed;
  z-index: 99999999999;

  width: ${({ _width }) => _width}px;

  transition: ${({ _thumbnailMode }) =>
    _thumbnailMode
      ? 'none'
      : '0.3s ease opacity, 0.3s ease margin, 0.3s ease visibility'};

  ${({ _openWindow }) =>
    _openWindow
      ? `
    pointer-events: all;
    touch-action: auto;
    visibility: visible;
    margin-bottom: 20px;
    opacity: 1;
  `
      : `
    pointer-events: none;
    touch-action: none;
    visibility: hidden;
    margin-bottom: 0;
    opacity: 0;
  `}
`;
